import React from "react";
import { useNavigate } from "react-router-dom";
import { API_URL } from "..";
import Swal from "sweetalert2";
import { Icon } from '@iconify/react/dist/iconify.js';

const CustomerTable = ({ data, currentPage, totalPages, onPageChange, limit, onLimitChange, searchQuery, onSearchChange }) => {
  const navigate = useNavigate();

  const handleDelete = async (id) => {
    try {
      const response = await fetch(`${API_URL}/api/customer/delete-single/${id}/false`, {
        method: "DELETE",
      });
      const result = await response.json();

      if (response.status === 200) {
        window.location.reload();
      } else if (result.message === "Error delete customer") {
        const swalResult = await Swal.fire({
          icon: "warning",
          title: "Warning",
          text: "This customer has jobs which are linked. Are you sure you want to delete this customer? This also removes the jobs data too.",
          showCancelButton: true,
          showConfirmButton: true,
          cancelButtonText: "Not Now",
          confirmButtonText: "I Agree",
        });

        if (swalResult.isConfirmed) {
          const forceDeleteResponse = await fetch(`${API_URL}/api/customer/delete-single/${id}/true`, {
            method: "DELETE",
            headers: { "Content-Type": "application/json" },
          });
          if (!forceDeleteResponse.ok) {
            throw new Error(`HTTP error! Status: ${forceDeleteResponse.status}`);
          }
          const forceDeleteData = await forceDeleteResponse.json();
          if (forceDeleteResponse.status === 200) {
            window.location.reload();
          } else {
            throw new Error(forceDeleteData.message || "Failed to delete customer");
          }
        }
      }
    } catch (error) {
      console.error("Error deleting customer:", error.message);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to delete customer",
      });
    }
  };

  // Filter data based on search query
  const filteredData = data.filter(customer =>
    customer.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
    customer.phone.toLowerCase().includes(searchQuery.toLowerCase()) ||
    customer.email.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div className="card basic-data-table">
      <div className="card-header">
        <div className="row align-items-center">
          <h5 className="card-title mb-0 col-md-4">List of Customers</h5>
          <div className="col-md-4">
            <input
              type="text"
              className="form-control"
              placeholder="Search by name, phone, or email"
              value={searchQuery}
              onChange={(e) => onSearchChange(e.target.value)}
            />
          </div>
          <div className="col-md-4 text-end">
            <div className="dropdown">
              <button
                className="btn btn-outline-primary dropdown-toggle"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Rows per page: {limit}
              </button>
              <ul className="dropdown-menu">
                {[10, 25, 50, 100,300].map((value) => (
                  <li key={value}>
                    <button
                      className="dropdown-item"
                      onClick={() => onLimitChange(value)}
                    >
                      {value}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="card-body">
        <div className="table-responsive">
          <table className="table table-bordered mb-3">
            <thead>
              <tr>
                <th scope="col">Name</th>
                <th scope="col">Phone</th>
                <th scope="col">Email</th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            <tbody>
              {filteredData.length > 0 ? (
                filteredData.map((customer) => (
                  <tr key={customer.id}>
                    <td>{customer.name}</td>
                    <td>{customer.phone}</td>
                    <td>{customer.email}</td>
                    <td>
                      <div className="dropdown">
                        <button
                          className="btn btn-outline-secondary dropdown-toggle"
                          type="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <Icon icon="ph:list" />
                        </button>
                        <ul className="dropdown-menu">
                          <li>
                            <button
                              className="dropdown-item"
                              onClick={() => navigate(`/customer/view/${customer.id}`)}
                            >
                              <Icon icon="ph:eye" className="me-1" /> View
                            </button>
                          </li>
                         
                        </ul>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" className="text-center">
                    No matching customers found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <div className="pagination-controls mt-3 d-flex justify-content-end align-items-center">
          <button
            className="btn btn-outline-primary me-2"
            onClick={() => onPageChange(currentPage - 1)}
            disabled={currentPage === 1}
          >
            Previous
          </button>
          <span className="mx-2">
            Page {currentPage} of {totalPages}
          </span>
          <button
            className="btn btn-outline-primary"
            onClick={() => onPageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default CustomerTable;